/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Exclusions_ValueInputs */

const en_us2_search_field_exclusions_value = /** @type {(inputs: Search_Field_Exclusions_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you asked us never to suggest`)
};

const pt_br2_search_field_exclusions_value = /** @type {(inputs: Search_Field_Exclusions_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que você pediu para não recomendar`)
};

const es_419_search_field_exclusions_value = /** @type {(inputs: Search_Field_Exclusions_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo que pediste que nunca te recomendemos`)
};

const pt_pt2_search_field_exclusions_value = /** @type {(inputs: Search_Field_Exclusions_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que pediste para nunca recomendarmos`)
};

const fr_fr2_search_field_exclusions_value = /** @type {(inputs: Search_Field_Exclusions_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce que tu nous as demandé de ne jamais suggérer`)
};

const de_de2_search_field_exclusions_value = /** @type {(inputs: Search_Field_Exclusions_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was wir dir nie vorschlagen sollen`)
};

const it_it2_search_field_exclusions_value = /** @type {(inputs: Search_Field_Exclusions_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciò che ci hai chiesto di non suggerire mai`)
};

/**
* | output |
* | --- |
* | "What you asked us never to suggest" |
*
* @param {Search_Field_Exclusions_ValueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_exclusions_value = /** @type {((inputs?: Search_Field_Exclusions_ValueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Exclusions_ValueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_exclusions_value(inputs)
	if (locale === "es-419") return es_419_search_field_exclusions_value(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_exclusions_value(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_exclusions_value(inputs)
	if (locale === "de-DE") return de_de2_search_field_exclusions_value(inputs)
	if (locale === "it-IT") return it_it2_search_field_exclusions_value(inputs)
	return en_us2_search_field_exclusions_value(inputs)
});
export { search_field_exclusions_value as "search.field_exclusions_value" }